import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CustomerUpdateModalUI from './CustomerUpdateModalUI.js'

class CustomerUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      submitted: false,
      // customerName attributes
      customerName: '',
      customerNameError: null,
      // contact attributes
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      // phoneNumber attributes
      phoneNumber: '',
      phoneNumberError: null,
      // email attributes
      email: '',
      emailError: null,
    }
  }

  render() {
    return (
      <CustomerUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        customerList={this.props.customerList}
        // update mode
        updateMode={this.props.updateMode}
        // customerName
        customerName={this.state.customerName}
        onCustomerNameChange={(event) => { this.setState({ customerName: event.target.value }) }}
        customerNameError={this.state.customerNameError}
        setCustomerNameError={(error) => { this.setState({ customerNameError: error }) }}
        // firstName
        firstName={this.state.firstName}
        onFirstNameChange={(event) => { this.setState({ firstName: event.target.value }) }}
        firstNameError={this.state.firstNameError}
        setFirstNameError={(error) => { this.setState({ firstNameError: error }) }}
        // lastName
        lastName={this.state.lastName}
        onLastNameChange={(event) => { this.setState({ lastName: event.target.value }) }}
        lastNameError={this.state.lastNameError}
        setLastNameError={(error) => { this.setState({ lastNameError: error }) }}
        // phoneNumber
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(value) => { this.setState({ phoneNumber: value }) }}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setState({ phoneNumberError: error }) }}
        // email
        email={this.state.email}
        onEmailChange={(event) => { this.setState({ email: event.target.value }) }}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setState({ emailError: error }) }}
        // form events
        onConfirmUpdateClick={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  componentDidUpdate(prevProps) {
    let customer = this.props.customer
    if (!customer)
      return
    if (prevProps.customer && prevProps.customer.customerId == customer.customerId)
      return

    this.setState({
      customerName: customer.customerName,
      firstName: customer.contactFirstName,
      lastName: customer.contactLastName,
      phoneNumber: customer.contactPhone,
      email: customer.contactEmail
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let id = this.props.customer.customerId

    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/customers/${id}`,
      this.onSubmitCallback, {
      customerName: this.state.customerName,
      contactFirstName: this.state.firstName,
      contactLastName: this.state.lastName,
      contactPhone: this.state.phoneNumber,
      contactEmail: this.state.email
    });
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'customerName':
          this.setState({ customerNameError: error.message })
          break;
        case 'contactFirstName':
          this.setState({ firstNameError: error.message })
          break;
        case 'contactLastName':
          this.setState({ lastNameError: error.message })
          break;
        case 'contactPhone':
          this.setState({ phoneNumberError: error.message })
          break;
        case 'contactEmail':
          this.setState({ emailError: error.message })
          break;
        default:
      }
    })

    if (response.errorList.length !== 0) {
      this.setState({
        errorList: errorList,
        submitted: false,
      })

      return;
    }

    this.setState({
      successMsg: response.success,
      submitted: false,
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)

    this.props.onUpdateComplete(response.customer)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      customerName: this.props.customer.customerName,
      firstName: this.props.customer.contactFirstName,
      lastName: this.props.customer.contactLastName,
      phoneNumber: this.props.customer.contactPhone,
      email: this.props.customer.contactEmail,
      customerNameError: null,
      firstNameError: null,
      lastNameError: null,
      phoneNumberError: null,
      emailError: null,
      submitted: false
    })

    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update_customer',
      'c_update',
      'c_cancel',
      'c_customer_name',
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_phone_number',
      'c_email'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('cust_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(CustomerUpdateModalSF)
